<!-- /**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */ -->
<template>
  <div>
    <v-row>
      <v-col>
        <ValidationProvider
          v-slot="{ errors, invalid, touched }"
          name="Nombre de hallazgo"
          rules="required"
        >
          <v-text-field
            v-model="model.name"
            :counter="100"
            label="Nombre de hallazgo"
            required
            autocomplete="off"
            :error-messages="errors"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col>
        <ValidationProvider
          v-slot="{ errors, invalid, touched }"
          name="Tipo de espacio físico"
          rules="required"
        >
          <v-text-field
            v-model="model.typeFindingKey"
            :error-messages="errors"
            :counter="15"
            label="Clave"
            required
            autocomplete="off"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  props: {
    model: Object,
  },
  components: {
    ValidationProvider,
  },
  data() {
    return {};
  },
};
</script>
